export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getBusinessContactList: function getBusinessContactList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business_contact/get",
        method: "get",
        params: data
      });
    },
    addBusinessContact: function addBusinessContact() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business_contact/add",
        method: "post",
        data: data
      });
    },
    updateBusinessContact: function updateBusinessContact() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business_contact/update",
        method: "post",
        data: data
      });
    },
    setDefaultBusinessContact: function setDefaultBusinessContact() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/business_contact/setDefault",
        method: "post",
        data: data
      });
    },
    getBusinessContactConfig: function getBusinessContactConfig() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/getBusinessContact",
        method: "post",
        data: data
      });
    },
    setBusinessContact: function setBusinessContact() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/setBusinessContact",
        method: "post",
        data: data
      });
    }
  };
});